import { render, staticRenderFns } from "./EntitySubMenu.vue?vue&type=template&id=18c4ee8c&scoped=true&"
import script from "./EntitySubMenu.vue?vue&type=script&lang=js&"
export * from "./EntitySubMenu.vue?vue&type=script&lang=js&"
import style0 from "./EntitySubMenu.vue?vue&type=style&index=0&id=18c4ee8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4ee8c",
  null
  
)

export default component.exports